import React from "react";
import { useTranslation } from "react-i18next";

const ExamplesConfigSection = ({ config, handleInputChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <div className="param-group">
      <div className="param-group-header">
        <h3 className="param-group-title">
          <span>💡</span>
          {t("sections.examples.title")}
        </h3>
      </div>

      <div className="param-grid">
        <div className="form-group">
          <label className="form-label" htmlFor="examplePlacement">
            {t("sections.examples.placement")}
          </label>
          <select
            id="examplePlacement"
            className="form-input"
            value={config.examples?.inline !== false ? "inline" : "annexe"}
            onChange={(e) =>
              handleInputChange("examples.inline", e.target.value === "inline")
            }
            disabled={disabled}
          >
            <option value="inline">{t("sections.examples.inline")}</option>
            <option value="annexe">{t("sections.examples.annexe")}</option>
          </select>
        </div>
        {config.outputFormat !== "markdown" && (
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
          <div className="form-group">
            <label className="form-label" htmlFor="exampleFontSize">
              {t("sections.examples.fontSize")}
            </label>
            <select
              id="exampleFontSize"
              className="form-input"
              value={config.examples?.fontSize || 10}
              onChange={(e) =>
                handleInputChange("examples.fontSize", parseInt(e.target.value))
              }
              disabled={disabled}
            >
              <option value="8">8px</option>
              <option value="9">9px</option>
              <option value="10">10px</option>
              <option value="11">11px</option>
              <option value="12">12px</option>
              <option value="13">13px</option>
              <option value="14">14px</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="exampleLineSpacing">
              {t("sections.examples.lineSpacing")}
            </label>
            <select
              id="exampleLineSpacing"
              className="form-input"
              value={config.examples?.lineSpacing || 1.1}
              onChange={(e) =>
                handleInputChange(
                  "examples.lineSpacing",
                  parseFloat(e.target.value)
                )
              }
              disabled={disabled}
            >
              <option value="1.0">1.0</option>
              <option value="1.05">1.05</option>
              <option value="1.1">1.1</option>
              <option value="1.15">1.15</option>
              <option value="1.2">1.2</option>
              <option value="1.25">1.25</option>
              <option value="1.3">1.3</option>
              <option value="1.4">1.4</option>
              <option value="1.5">1.5</option>
              <option value="1.6">1.6</option>
              <option value="1.8">1.8</option>
              <option value="2.0">2.0</option>
            </select>
          </div>
          {config.examples?.inline && (
            <>
              <div className="form-group">
                <label className="form-label" htmlFor="exampleMarginX">
                  {t("sections.examples.marginX")}
                </label>
                <select
                  id="exampleMarginX"
                  className="form-input"
                  value={
                    config.examples.marginX === undefined
                      ? 4
                      : config.examples.marginX
                  }
                  onChange={(e) =>
                    handleInputChange(
                      "examples.marginX",
                      parseInt(e.target.value)
                    )
                  }
                  disabled={disabled}
                >
                  <option value="0">0px</option>
                  <option value="2">2px</option>
                  <option value="4">4px</option>
                  <option value="6">6px</option>
                  <option value="8">8px</option>
                  <option value="10">10px</option>
                  <option value="15">15px</option>
                  <option value="20">20px</option>
                  <option value="25">25px</option>
                  <option value="30">30px</option>
                  <option value="35">35px</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="exampleMarginY">
                  {t("sections.examples.marginY")}
                </label>
                <select
                  id="exampleMarginY"
                  className="form-input"
                  value={config.examples?.marginY || 10}
                  onChange={(e) =>
                    handleInputChange(
                      "examples.marginY",
                      parseInt(e.target.value)
                    )
                  }
                  disabled={disabled}
                >
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="8">8</option>
                  <option value="10">10</option>
                  <option value="12">12</option>
                  <option value="15">15</option>
                  <option value="18">18</option>
                  <option value="22">22</option>
                </select>
              </div>
            </>
          )}
        </div>
        )}
      </div>

      {/* Couleurs et style des exemples */}
      {config.examples?.inline && config.outputFormat !== "markdown" && (
        <div className="mt-2 param-group bg-secondary-100">
          <h4 className="param-group-title">
            <span>🎨</span>
            {t("sections.examples.colorsAndStyle")}
          </h4>

          <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
            <div className="form-group">
              <label className="form-label" htmlFor="exampleBgColor">
                {t("sections.examples.backgroundColor")}
              </label>
              <input
                type="color"
                id="exampleBgColor"
                className="p-1 w-5/6 h-10 form-input"
                value={config.examples?.bgColor || "#f9f9f2"}
                onChange={(e) =>
                  handleInputChange("examples.bgColor", e.target.value)
                }
                disabled={disabled}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="exampleBorderColor">
                {t("sections.examples.borderColor")}
              </label>
              <input
                type="color"
                id="exampleBorderColor"
                className="p-1 w-5/6 h-10 form-input"
                value={config.examples?.borderColor || "#e6e680"}
                onChange={(e) =>
                  handleInputChange("examples.borderColor", e.target.value)
                }
                disabled={disabled}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="exampleRadius">
                {t("sections.examples.radius")}
              </label>
              <select
                id="exampleRadius"
                className="form-input"
                value={
                  config.examples.radius === undefined
                    ? 12
                    : config.examples.radius
                }
                onChange={(e) =>
                  handleInputChange("examples.radius", parseInt(e.target.value))
                }
                disabled={disabled}
              >
                <option value="0">0px</option>
                <option value="4">4px</option>
                <option value="8">8px</option>
                <option value="12">12px</option>
                <option value="16">16px</option>
                <option value="20">20px</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="exampleOpacity">
                {t("sections.examples.opacity")}
              </label>
              <select
                id="exampleOpacity"
                className="form-input"
                value={config.examples?.opacity || 0.8}
                onChange={(e) =>
                  handleInputChange(
                    "examples.opacity",
                    parseFloat(e.target.value)
                  )
                }
                disabled={disabled}
              >
                <option value="0.3">30%</option>
                <option value="0.4">40%</option>
                <option value="0.5">50%</option>
                <option value="0.6">60%</option>
                <option value="0.7">70%</option>
                <option value="0.8">80%</option>
                <option value="0.9">90%</option>
                <option value="1.0">100%</option>
              </select>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExamplesConfigSection;
